module.exports = __webpack_public_path__ + "static/media/teacher_view_create_section_video.e6d6efd3.mov";